export default __webpack_public_path__ + "9272cba957965cff5e2f6cda361ab1fc.jpg";